'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Map;

exports.buildResponderMap = buildResponderMap;

var _immutable = require('immutable');

var _responderGetters = require('./responderGetters');

var _Responder = require('../records/Responder');

var _Responder2 = _interopRequireDefault(_Responder);

var _senderTypes = require('../../pubnub-message/constants/senderTypes');

var _strings = require('../../constants/strings');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var emptyResponderMap = (0, _immutable.Map)((_Map = {}, _defineProperty(_Map, _senderTypes.AGENT, (0, _immutable.Map)()), _defineProperty(_Map, _senderTypes.BOT, (0, _immutable.Map)()), _Map));

function buildResponderMap() {
  var respondersArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var responderMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : emptyResponderMap;

  return respondersArray.reduce(function (map, responderObject) {
    var responder = (0, _Responder2.default)(responderObject);
    var userId = (0, _responderGetters.getUserId)(responder);

    if ((0, _responderGetters.getIsBot)(responder)) {
      var botWithName = responder.update('firstName', function (firstName) {
        return firstName || _strings.DEFAULT_BOT_NAME;
      });

      // krb: temporarily add bots to both maps of responders
      return map.setIn([_senderTypes.AGENT, userId], botWithName).setIn([_senderTypes.BOT, userId], botWithName);
    }

    return map.setIn([_senderTypes.AGENT, userId], responder);
  }, responderMap);
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/responders/operators/buildResponderMap.js
// module id = 880
// module chunks = 2 3